export default __webpack_public_path__ + "static/media/logo-login.1e7104e7.svg";